import { UPDATE_PARAMGROUP, UPDATE_PARAMGROUP_SUCCESSFUL,UPDATE_PARAMGROUP_FAILED } from './actionTypes';

const initialState = {
    updateParamGroupError: null, messageUpdateParam: null, loadingUpdateParamGroup: false
}

const updateParamGroup = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_PARAMGROUP:
            state = {
                ...state,
                loadingUpdateParamGroup: true,
                updateParamGroupError: null
            }
            break;
        case UPDATE_PARAMGROUP_SUCCESSFUL:
            state = {
                ...state,
                loadingUpdateParamGroup: false,
                messageUpdateParam: action.payload,
                updateParamGroupError: null
            }
            break;
        case UPDATE_PARAMGROUP_FAILED:
            state = {
                ...state,
                messageUpdateParam: null,
                loadingUpdateParamGroup: false,
                updateParamGroupError: action.payload
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default updateParamGroup;